import { FC } from 'react';
import { Box, Typography, AnimatedShape } from '@altermaind/web/ui';

export const StartQuizSkeleton: FC = () => {
  return (
    <Box>
      <Typography variant='p2/light' color='primary/text'>
        <AnimatedShape height={15} width='100%' variant='semiRound' mb='xxs' />
        <AnimatedShape height={15} width='100%' variant='semiRound' mb='xxs' />
        <AnimatedShape height={15} width='100%' variant='semiRound' mb='xxs' />
        <AnimatedShape height={15} width='30%' variant='semiRound' mb='xxs' />
      </Typography>
      <Typography variant='p3/light' color='primary/text' mt='m'>
        <AnimatedShape height={15} width='60%' variant='semiRound' mb='xxs' />
      </Typography>
    </Box>
  );
};
